import { render, staticRenderFns } from "./InvestmentTermRefont.vue?vue&type=template&id=4cb2dd39"
import script from "./InvestmentTermRefont.vue?vue&type=script&lang=js"
export * from "./InvestmentTermRefont.vue?vue&type=script&lang=js"
import style0 from "./InvestmentTermRefont.vue?vue&type=style&index=0&id=4cb2dd39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports